export default __webpack_public_path__ + "static/media/check-square.6ffba6b5.svg";